import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app/checkbox-checked",
  "use": "app/checkbox-checked-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"app/checkbox-checked\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 2.5h14A2.5 2.5 0 0121.5 5v14a2.5 2.5 0 01-2.5 2.5H5A2.5 2.5 0 012.5 19V5A2.5 2.5 0 015 2.5zM1 5a4 4 0 014-4h14a4 4 0 014 4v14a4 4 0 01-4 4H5a4 4 0 01-4-4V5zm6.008 7.262l3.73 3.731L17.5 9.231l-.966-.966-5.795 5.792-2.764-2.764-.967.97z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol